export default __webpack_public_path__ + "static/media/Canetas.9807f1ab.png";